/**
 * getIMEI
 * @author marvinqi
 * @createTime 2017/9/20
 */

import getUA from './getUA'
export default function () {
  return (/\bimei\/([\w\-]+)/i.exec(getUA()) || ['', '0'])[1] //IMEI号
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/getIMEI.js